import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import moment from 'moment';
import {
  CmReasonDto,
  ContractDto,
  GetCmReasonResponse,
} from 'src/app/api/invoice/models';
import { InvoiceConfirmComponent } from 'src/app/module/MCC/mcc-invoice/invoice-confirm/invoice-confirm.component';
import { CreditConfirmRequest } from '../../models/user.model';
import { CmReasonService } from 'src/app/api/invoice/services';

@Component({
  selector: 'app-confirm-credit-note',
  templateUrl: './confirm-credit-note.component.html',
  styleUrls: ['./confirm-credit-note.component.scss'],
})
export class ConfirmCreditNoteComponent implements OnInit {
  invoiceForm: UntypedFormGroup;
  id = '';
  createLoading = false;
  error = '';
  successResponse = '';
  editMode = false;
  contractDetails: ContractDto = {};
  date = '';
  initialDate = new Date();
  processing = false;
  reasonOptions: CmReasonDto[] = [];
  minDate: any;
  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<InvoiceConfirmComponent>,
    private dialog: MatDialog,
    private cmReasonService: CmReasonService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      id: string;
      module: string;
      heading?: string;
      isCreditNote?: boolean;
      serviceDate?: string;
    }
  ) {
    this.id = data.id;
    this.invoiceForm = this.fb.group({
      date: new UntypedFormControl(this.initialDate, [Validators.required]),
      reason: new UntypedFormControl('', [Validators.required]),
      showUsd: new UntypedFormControl(false),
      ebsReason: new UntypedFormControl(null),
    });
  }
  ngOnInit(): void {
    this.loadCmReasons();

    if (this.data?.isCreditNote) {
      this.invoiceForm.get('ebsReason')?.setValidators([Validators.required]);
      this.invoiceForm.get('ebsReason')?.updateValueAndValidity();
    } else {
      this.invoiceForm.get('ebsReason')?.clearValidators();
      this.invoiceForm.get('ebsReason')?.updateValueAndValidity();
    }

    this.minDate = this.data?.serviceDate
      ? moment(this.data.serviceDate).toDate()
      : null;
  }
  closeModal() {
    this.dialog.closeAll();
  }
  loadCmReasons(): void {
    this.cmReasonService
      .getAllCmReasons({ page: 0, size: 100, sort: 'id,asc' })
      .subscribe({
        next: (res: GetCmReasonResponse) => {
          this.reasonOptions = res?.data?.[0]?.data ?? [];
        },
        error: err => console.error('Failed to load CM reasons', err),
      });
  }
  onSubmit() {
    // Mark all fields as touched so validation messages appear
    this.invoiceForm.markAllAsTouched();
    if (this.invoiceForm.valid) {
      this.processing = true;
      const formdata: CreditConfirmRequest = {
        serviceDate: moment(this.invoiceForm.value?.date).format('YYYY-MM-DD'),
        reason: this.invoiceForm?.value?.reason,
        showUsd: this.invoiceForm?.value?.showUsd,
        ebsReasonId: this.invoiceForm?.value?.ebsReason,
      };

      this.dialogRef.close(formdata);
    }
  }
}
